import React, { FC } from 'react'

interface IJsonLdProps {
  content: string
}

const JsonLd: FC<IJsonLdProps> = ({ content }) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}

export default JsonLd
